<template>
  <v-tabs color="grey" background-color="grey lighten-4">
    <v-tabs-slider />
    <v-tab href="#tab-concierge" class="text-none grey--text">
      {{ $t('BUILDING_COMPLEXES.CONCIERGE_INFO') }}
    </v-tab>
    <v-tab href="#tab-additional" class="text-none grey--text">
      {{ $t('PROFILE.ADDITIONAL_INFO') }}
    </v-tab>
    <v-tab
      v-if="!isCreated && readonly"
      href="#tab-related-companies"
      class="text-none grey--text"
    >
      {{ $t('RELATED_COMPANIES.NOTRUF') }}
    </v-tab>
    <v-tab href="#tab-docs" class="text-none grey--text">
      {{ $t('DOCUMENTS.ITEMS') }}
    </v-tab>
    <v-tab
      v-if="!isCreated && readonly"
      href="#tab-contracts"
      class="text-none grey--text"
    >
      {{ $t('CONTRACTS.BASIC_FEE') }}
    </v-tab>
    <v-tab href="#tab-password" class="text-none grey--text">
      {{ $t('PROFILE.CHANGE_PASSWORD.SUBTITLE') }}
    </v-tab>
    <v-tab href="#tab-map" class="text-none grey--text">
      {{ $t('DASHBOARD.MAP') }}
    </v-tab>

    <v-tab-item value="tab-additional" eager>
      <additional-info-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        :action="!isCreated && readonly ? 'show' : 'edit'"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item value="tab-map" eager
      ><map-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item value="tab-password" eager>
      <app-settings-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item value="tab-concierge" eager>
      <concierge-info-tab-form
        v-model="form"
        :readonly="readonly"
        :action="action"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item value="tab-docs" eager>
      <lists-filter
        v-model="form.list_of_document_id"
        :readonly="readonly"
        item-value="id"
        item-text="name"
        :clearable="!readonly"
        :label="`${$t('DOCUMENTS.ITEMS')} ${$t('LISTS.ITEM')}`"
        :error-messages="errors.list_of_document_id"
        @change="updateValue('list_of_document_id', $event)"
      />
    </v-tab-item>
    <v-tab-item value="tab-contracts" eager>
      <contracts
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item value="tab-related-companies">
      <related-companies
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import AdditionalInfoForm from '@/modules/building_complexes/components/forms/Tabs/AdditionalInfoForm';
import formEditable from '@/modules/_global/mixins/form-editable';
import RelatedCompanies from '@/modules/building_complexes/components/forms/Tabs/RelatedCompany/RelatedCompanies';
import MapForm from '@/modules/building_complexes/components/forms/Tabs/MapForm';
import AppSettingsForm from '@/modules/building_complexes/components/forms/Tabs/AppSettingsForm';
import ConciergeInfoTabForm from '@/modules/building_complexes/components/forms/Tabs/ConciergeInfoTabForm';
import Contracts from '@/modules/building_complexes/components/forms/Tabs/Contracts/Contracts';
import ListsFilter from '@/modules/documents_lists/components/forms/filters/ListsFilter.vue';

export default {
  name: 'BuildingComplexTabsForm',

  components: {
    ListsFilter,
    Contracts,
    RelatedCompanies,
    ConciergeInfoTabForm,
    AppSettingsForm,
    MapForm,
    AdditionalInfoForm
  },

  mixins: [formEditable],

  computed: {
    isCreated() {
      return !this.form.id;
    }
  }
};
</script>

<style scoped></style>
